(function ($) {
  $(function () {
    if ($('.pricing-table').length && $('.pricing-table .info').length) {
      $('.pricing-table .info').on('click', function () {
        if ($(window).width() < 768) {
          $('.pricing-table .info.hovered').not(this).removeClass('hovered');
          $(this).toggleClass('hovered');
        }
      });

      $(window).on('resize', function () {
        if ($(window).width() >= 768) {
          $('.pricing-table .info.hovered').removeClass('hovered');
        }
      });
    }
  });
})(jQuery);